import { res, dateFormat } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
export default {
    async searchList(
        page: number,
        size: number,
        searchType: number,
        startDate: string,
        endDate: string,
        type: string,
        searchContent: string,
        idxList: string | null = null,
    ): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/search/info/excel/download",
                {
                    page,
                    size,
                    searchType,
                    startDate,
                    endDate,
                    type: type,
                    searchContent,
                    idxList: idxList ? idxList : null,
                },
                { withCredentials: false, responseType: "blob" },
            );
            return response;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async resultList(idx: number, page: number, size: number, filterList: any, idxList: string | null = null): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/search/result/excel/download/" + idx,
                {
                    page,
                    size,
                    searchType: filterList.searchType,
                    sns: filterList.sns,
                    type: filterList.type,
                    resultType: filterList.resultType,
                    resultDetailType: filterList.resultDetailType,
                    nation: filterList.nation,
                    searchContent: filterList.searchContent,
                    isMonitoring: filterList.isMonitoring,
                    idxList: idxList ? idxList : null,
                },
                { withCredentials: false, responseType: "blob" },
            );
            return response;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async monitoringList(status: number | null, page: number, size: number, filterList: any): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/search/monitoring/excel/download",
                {
                    page,
                    size,
                    searchType: filterList.searchType,
                    sns: filterList.sns,
                    type: filterList.type,
                    resultType: filterList.resultType,
                    resultDetailType: filterList.resultDetailType,
                    nation: filterList.nation,
                    searchContent: filterList.searchContent,
                    startDate: dateFormat(new Date(filterList.date[0])),
                    endDate: dateFormat(new Date(filterList.date[1])),
                    status: status,
                },
                { withCredentials: false, responseType: "blob" },
            );
            return response;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async memberList(
        page: number,
        size: number,
        name: string | null,
        dept: number,
        position: number,
        idxList: string | null = null,
    ): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/member/excel/download",
                {
                    page,
                    size,
                    name,
                    dept,
                    position,
                    idxList: idxList ? idxList : null,
                },
                { withCredentials: false, responseType: "blob" },
            );
            return response;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async statist(date: Array<Date>): Promise<res> {
        const res = {} as res;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(
                "/statistics/excel/download",
                {
                    startDate: date[0],
                    endDate: date[1],
                },
                { withCredentials: false, responseType: "blob" },
            );
            return response;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
};
